//constants
import { GET_SUBSCRIPTION_TRANSACTION_HISTORY, GET_USER_MAPPING_LIST, GET_PRODUCT_PLAN_INFO, CREATE_TRANSACTION_V2, CLEAN_CREATE_TRANSACTION_DATA, GET_PAYMENT_METHODS, CLEAN_PAYMENT_METHOD_DATA } from "./Constants";

const INITIAL_STATE = {
  subscriptionTransactionHistory: {
      transactions:""
  },
  userMappingsList: {
    totalAlertCount: "",
    selfAlertCount: "",
    monitoredUsers: [],
    monitoringUsers: [],
    invitees: {},
    invites: {}
  },
  productPlanInfo: {
    products: []
  },
  createTransactionResponse:{},
  existingPaymentInfo: {
    paymentMethods: []
  }
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_SUBSCRIPTION_TRANSACTION_HISTORY:
      return {
        ...state,
        subscriptionTransactionHistory: {
          ...state.subscriptionTransactionHistory,
          transactions: action.response.transactions ? action.response.transactions : [],
        },
      };

    case GET_USER_MAPPING_LIST:
      return {
        ...state,
        userMappingsList: {
          ...state.userMappingsList,
          totalAlertCount: action.response.total_alert_count ? action.response.total_alert_count : "", 
          selfAlertCount: action.response.self_alert_count ? action.response.self_alert_count : "",
          monitoredUsers: action.response.monitored_users ? action.response.monitored_users : [],
          monitoringUsers: action.response.monitoring_users ? action.response.monitoring_users : [], 
          invitees: action.response.invitees ? action.response.invitees : {},
          invites: action.response.invites ? action.response.invites : {}
        }
      };  
    
    case GET_PRODUCT_PLAN_INFO:
      return {
        ...state,
        productsPlanInfo: {
          ...state.productPlanInfo,
          products: action.response.products ? action.response.products : [],
        }
      };
      
    case CREATE_TRANSACTION_V2:
      return {
        ...state,
        createTransactionResponse: {
          ...state.createTransactionResponse,
          data: action.response
        }, 
      }
      
    case CLEAN_CREATE_TRANSACTION_DATA:
      return {
        ...state,
        createTransactionResponse: {
          ...state.createTransactionResponse,
          data:""
        }
      }  

    case GET_PAYMENT_METHODS:
      return {
        ...state,
        existingPaymentInfo: {
          ...state.existingPaymentInfo,
          paymentMethods: action.response.paymentMethods ? action.response.paymentMethods : [],
        }
      };

    case CLEAN_PAYMENT_METHOD_DATA:
      return {
        ...state,
        existingPaymentInfo: {
          ...state.existingPaymentInfo,
          paymentMethods:[]
        }
      }    
    default:
      return state;
  }
}
